import { Link } from "react-router-dom";
import { characters } from "@/mocks/characters";
import { relationships } from "@/mocks/relationships";

const ROLE_TONE: Record<string, string> = {
  师兄: "bg-primary-100 text-primary-700",
  师姐: "bg-secondary-100 text-secondary-700",
  师弟: "bg-accent-100 text-accent-700",
  师妹: "bg-secondary-100 text-secondary-700",
  师尊: "bg-accent-100 text-accent-700",
  对手: "bg-primary-100 text-primary-700",
  外门: "bg-background-200 text-foreground-700",
};

export default function RelationsSpotlight() {
  const moments = relationships.filter((r) => r.type === "师姐互动");
  const featured = characters.filter((c) => c.closeness >= 78);

  return (
    <>
      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
          <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
            <div>
              <p className="text-xs font-medium tracking-[0.3em] text-primary-600">RELATIONS</p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
                云隐峰 · 核心人物
              </h2>
              <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-600">
                师门上下谁亲谁疏、谁是谁的软肋，先从这些关键人物开始认识。
              </p>
            </div>
            <Link
              to="/relations"
              className="whitespace-nowrap rounded-md border border-primary-200 px-5 py-2.5 text-sm text-primary-700 transition-colors hover:bg-primary-50"
            >
              查看完整关系图
            </Link>
          </div>

          <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {featured.map((c) => (
              <article
                key={c.id}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1"
              >
                <div className="relative h-52 w-full overflow-hidden md:h-56">
                  <img src={c.portrait} alt={`${c.name} ${c.title} 水墨人像`} className="h-full w-full object-cover object-top" />
                  <span
                    className={`absolute left-3 top-3 rounded-full px-3 py-1 text-xs ${ROLE_TONE[c.role]}`}
                  >
                    {c.role}
                  </span>
                </div>
                <div className="p-5">
                  <div className="flex items-center justify-between">
                    <h3 className="font-heading text-lg text-foreground-950">{c.name}</h3>
                    <span className="text-xs text-foreground-500">{c.title}</span>
                  </div>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {c.tags.map((t) => (
                      <span key={t} className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800">
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-medium tracking-[0.3em] text-primary-600">SISTER MOMENTS</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            师姐互动名场面
          </h2>
          <div className="gold-line mx-auto mt-4 h-px w-16"></div>
          <p className="mt-4 text-sm leading-7 text-foreground-600">
            一冷一热、一针一线，师姐们把"护短"与"默契"演成了名场面。
          </p>
        </div>

        <div className="mx-auto mt-12 grid max-w-5xl grid-cols-1 gap-4 md:grid-cols-2">
          {moments.map((m, i) => (
            <article key={m.id} className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-500/15 text-accent-700">
                <i className="ri-quill-pen-line text-xl" />
              </span>
              <div>
                <p className="text-xs tracking-widest text-primary-600">名场面 #{String(i + 1).padStart(2, "0")}</p>
                <h3 className="mt-1 font-heading text-lg text-foreground-950">{m.pair}</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{m.note}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}